import type React from 'react';

import { ForgotPasswordForm } from '@/components/ForgotPasswordForm';
import { AuthLayout } from './AuthLayout';

export const ForgotPasswordView: React.FC = () => {
  return (
    <AuthLayout>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: 'calc(100vh - 64px)',
        }}
      >
        <ForgotPasswordForm />
      </div>
    </AuthLayout>
  );
};
